enum GridCellKey {
  // Normal (GridView) values
  EMPTY = 'EMPTY',
  NO_CONTENTS = 'NO_CONTENTS',
  WITH_CONTENTS = 'WITH_CONTENTS',
  NON_BLOCKING_STATUS_WARNING = 'NON_BLOCKING_STATUS_WARNING',
  BLOCKING_STATUS_WARNING = 'BLOCKING_STATUS_WARNING',

  // Values for MoveSummaryModal
  CREATE = 'CREATE',
  MOVE_IN = 'MOVE_IN',
  REPOSITION = 'REPOSITION',
  NO_CHANGE = 'NO_CHANGE',
  CREATE_MOVE_OUT = 'CREATE_MOVE_OUT',
  MOVE_IN_MOVE_OUT = 'MOVE_IN_MOVE_OUT',
  EMPTY_MOVE_OUT = 'EMPTY_MOVE_OUT',
  REPOSITION_MOVE_OUT = 'REPOSITION_MOVE_OUT',
  NO_CHANGE_MOVE_OUT = 'NO_CHANGE_MOVE_OUT',
  COPY_BARCODES = 'COPY_BARCODES',
}

export function getGridCellMoveOutKey(key: GridCellKey): GridCellKey {
  switch (key) {
    case GridCellKey.CREATE:
      return GridCellKey.CREATE_MOVE_OUT;
    case GridCellKey.MOVE_IN:
      return GridCellKey.MOVE_IN_MOVE_OUT;
    case GridCellKey.NO_CHANGE:
      return GridCellKey.NO_CHANGE_MOVE_OUT;
    case GridCellKey.EMPTY:
      return GridCellKey.EMPTY_MOVE_OUT;
    case GridCellKey.REPOSITION:
      return GridCellKey.REPOSITION_MOVE_OUT;
    default:
      throw new Error(`addMoveOut called with unknown value: ${key}`);
  }
}

export default GridCellKey;
